<script setup lang="ts">
import type { Item } from '@autobid/ui/types/components/AuctionsData'

interface Props {
  type: Item['type']
}

defineProps<Props>()
</script>

<template>
  <span
    v-if="type !== 'ONLINE'"
    class="font-semi relative flex aspect-square h-[32px] w-[32px] items-center justify-center rounded-full bg-primary text-lg font-semibold text-white"
  >
    <span class="text-md m-0 p-0">
      {{ type[0] }}
    </span>
  </span>
  <CommonIconClock v-else class="h-8 w-8 text-primary" />
</template>
